import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import App from './App' 
import reportWebVitals from './reportWebVitals'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './Store/store'
import Dashboard from './Componest/Dashboard/Dashboard'
import Login from './Componest/Loging/Login'
import Logout from './Componest/Logout/logout'
import ResetCredentials from './Componest/Loging/ResetCredentials'
import Register from './Componest/Register/register'
import UserControl from './Componest/UserControl/UserControl'
import ForgotPassword from './Componest/Loging/ForgotPassword'
import PIN from './Componest/Loging/PIN'
import CatNotificaciones from './Componest/Catalogos/CatNotificaciones'
import CatRelacionBookPrecta from './Componest/Catalogos/CatRelacionBookPrecta/CatRelacionBookPrecta'
import FileUploadExel from './Componest/Catalogos/FileUploadExel'
import FileUploadExelWorkingHours  from './Componest/Catalogos/CatWorkingHours/FileUploadExelWorkingHours'
import RptTotalHours from './Componest/Reportes/RptTotalHours/RptTotalHours'
import CatEmpleados from './Componest/Catalogos/CatEmpleados/CatEmpleados'
import RptLogEdicion from './Componest/Reportes/RptLogEdiciom'
import VacacionesComponent from './Componest/Catalogos/CatVacaciones/VacacionesComponent'
import UsuarioDashboard from './Home/UserDashboard'
import ControlJefeVacaciones from './Componest/Catalogos/ControlVacaciones/ControlJefeVacaciones'
import VacacionAccepted from './Componest/Reportes/RptVacacionAccepted/VacacionAccepted'
import CatDiasFestivos from './Componest/Catalogos/CatDiasFestivos/CatDiasFestivos'
import RHVacacionesComponent from './Componest/Catalogos/CatVacaciones/RhVacacionesComponent'
import CatPermisosUsuario from './Componest/Catalogos/CatPermisos/CatPermisosUsuario'
import ControlPermisos from './Componest/Catalogos/ControlPermisos/ControlJefePermisos'
import PermisoAccepted from './Componest/Reportes/RptPermisos/PermisosAccepted'
import EntradasSalidasRango from './Componest/Catalogos/CatalogosReloj/EntradasSalidasRango'
import CatPermisos from './Services/Catalogos/CatPermisos'
import ControlPermisosRH from './Componest/Catalogos/CatPermisos/CarPermisosRH'
import NotificacionRetardos from './Componest/Catalogos/CatalogosReloj/NotificacionRetardos'
import RhVacacionesInactivas from './Componest/Catalogos/CatVacaciones/RhVacacionesInactivas'
import ReportePrenomina from './Componest/Reportes/RptNomina/RptNomina'
import ReportePrenominaRh from './Componest/Reportes/RptNomina/RptNominaRh'
import CatClavesNomina from './Componest/Catalogos/CatNomina/CatNominaClaves'
import EntradasSalidasReloj from './Componest/Catalogos/CatalogosReloj/EntradasSalidasReloj'
import AdministrarNomina from './Componest/Register/UserList/AministrarNomita'
import DireccionRptVacaciones from './Componest/Catalogos/CatVacaciones/DireccionRptVacaciones'
import ControlContrasenas from './Componest/Catalogos/CatSistemas/ControlContrasenas'
import RptTotalHoursParaSupervisor from './Componest/Reportes/RptTotalHours/RptTotalHoursParaSupervisor'
import CatSistemasEmpleados from './Componest/Catalogos/CatEmpleados/CatSistemasEmpleados'
import ControlContrasenasGenerales from './Componest/Catalogos/CatSistemas/ControlContrasenasGenerales'
import InventarioEquipos from './Componest/Catalogos/Inventario/InventarioEquipos'
import RptHorarioTEGeneral from './Componest/Reportes/RptHorarioTE/RptHorarioTEGeneral'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

function PageNotFound() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '300px' }}>
      <h2>Sorry, no matching page</h2>
    </div>
  )
}

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route path='/' element={<App />}>
            <Route path='/' element={<Dashboard />} />
            <Route path='/login' element={<Login />} />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path='/PIN' element={<PIN />} />
            <Route path='/logout' element={<Logout />} />
            <Route path ='/Reset' element={<ResetCredentials />} />
            <Route path='/Register' element={<Register />} />
            <Route path='/CatNotificaciones' element={<CatNotificaciones/>} />
            <Route path='/RptTotalHours' element = {<RptTotalHours/>}  /> 
            <Route path='FileUploadExel' element= {<FileUploadExel/>} />
            <Route path='/UserControl' element={<UserControl />} />
            <Route path='/CatRelacionBookPrecta' element ={<CatRelacionBookPrecta />} />
            <Route path='*' element={<PageNotFound />} />
            <Route path='FileUploadExelWorkingHours' element = {<FileUploadExelWorkingHours/>}  />  
            <Route path='CatEmpleados' element ={<CatEmpleados/>} />
            <Route path='RptLogEdition' element= {<RptLogEdicion/>   }   />    
            <Route path='VacacionesComponent' element = {<VacacionesComponent/>}   />  
            <Route path='ControlJefeVacaciones' element = {<ControlJefeVacaciones  /> }     />      
            <Route path="/usuario-dashboard" element={<UsuarioDashboard />} /> 
            <Route path='VacacionAccepted' element= {<VacacionAccepted />  } /> 
            <Route path='DiasFestivos' element= {<CatDiasFestivos /> } /> 
            <Route path='RhInsertVacaciones' element= {<RHVacacionesComponent />  } />
            <Route path='CatPermisosUsuario' element= {<CatPermisosUsuario /> } />
            <Route path ='ControlJefePermisos' element={<ControlPermisos />} />
            <Route path ='PermisosAccepted' element={<PermisoAccepted />} />
            <Route path='EntradasSalidasRango' element={<EntradasSalidasRango />} />
            <Route path='RHInsertarPermisos' element= {<ControlPermisosRH />   } /> 
            <Route path='NotificacionRetardos' element=  {<NotificacionRetardos /> } />
            <Route path = 'RhVacacionesInactivas' element = {<RhVacacionesInactivas /> } />
            <Route path='RptPrenomina' element = {<ReportePrenomina   />} />
            <Route path='RptPrenominaRh' element = {<ReportePrenominaRh   />} />
            <Route path='RptHorarioTEGeneral' element={<RptHorarioTEGeneral />} />
            <Route path='ClavesNomina' element = {<CatClavesNomina />  }   /> 
            <Route path='EntradasSalidaReloj' element = {<EntradasSalidasReloj /> }  /> 
            <Route path ='AdministrarNomina' element = {<AdministrarNomina  />  } /> 
            <Route path = 'DireccionRptVacaciones' element = {<DireccionRptVacaciones /> } /> 
            <Route path='ControlContrasenas' element = {<ControlContrasenas /> } />
            <Route path = 'RptTotalHoursSupervisor' element =  {<RptTotalHoursParaSupervisor />} />
            <Route path='AltaSistemasIT' element={<CatSistemasEmpleados />} />
            <Route path='ControlContrasenasGenerales'   element = {<ControlContrasenasGenerales />} />
           <Route path="/inventario" element={<InventarioEquipos />}/>


             
          </Route>
        </Routes>
      </HashRouter>
    </React.StrictMode>
  </Provider>
)
reportWebVitals()
